import React from 'react';
import styleHelper from '@client/shared/styles/styleHelper.scss';
import styles from '@client/containers/featuredCard/featuredCard.scss';
import { valueOrEmptyStr } from '@client/shared/utils/utils/utils';
import Image from '@client/components/image/Image';
import Markdown from '@client/components/markdown/Markdown';
import ReactLink from '@client/components/reactLink/ReactLink';

const FeaturedCard = ({
  title,
  imageUrl,
  subTitle,
  text,
  to,
  onClick,
  asterisk,
  buttonLabel,
}) => {
  return (
    <div
      className={`${styleHelper.layoutMobileSidePadding} ${styles.featuredCard}`}
    >
      {title && (
        <h3 className={`${styleHelper.titleMdPrimary} ${styles.title}`}>
          {title}
        </h3>
      )}
      <div className={`${styleHelper.grid12}`}>
        {imageUrl && (
          <div className={`${styles.imageContainer}`}>
            <Image className={styles.image} src={imageUrl} />
          </div>
        )}
        <div className={styleHelper.flexCol}>
          {subTitle && (
            <div className={`${styleHelper.titleSmPrimary} ${styles.subTitle}`}>
              {subTitle}
            </div>
          )}
          <div className={styles.description}>
            <Markdown
              className={styles.markdown}
              value={valueOrEmptyStr(text)}
            />
          </div>
          <div className={styleHelper.flexRow}>
            <ReactLink
              className={`${styleHelper.btnPrimaryMd} ${styles.btn}`}
              to={to}
              onClick={onClick && onClick}
            >
              {buttonLabel ? buttonLabel : 'Starta insamling'}
            </ReactLink>
          </div>
          {asterisk && <div className={styles.asterisk}>{asterisk}</div>}
        </div>
      </div>
    </div>
  );
};

export default FeaturedCard;
